(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yotpo-collections"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.course-yotpo-rating').forEach(async (element) => {
  const productIds = (element.dataset.yotpoProductIds || '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);

  if (!productIds.length) return;
  

  try {
    const results = await Promise.allSettled(
      productIds.map(async (productId) => {
        const response = await fetch(
          `https://api-cdn.yotpo.com/products/uz9LdRHboP99LLNcVMkW6eL9Gs4P8HcHsWfZ2Ieq/${encodeURIComponent(productId)}/bottomline`,
          {
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) {
          throw new Error(
            `Yotpo request failed for ${productId}: ${response.status}`
          );
        }

        const data = await response.json();
        const bottomline = data?.response?.bottomline;

        return {
          productId,
          rating: Number(bottomline?.average_score) || 0,
          reviews: Number(bottomline?.total_reviews) || 0
        };
      })
    );

    const products = results
      .filter(result => result.status === 'fulfilled')
      .map(result => result.value);

    results
      .filter(result => result.status === 'rejected')
      .forEach(result => {
        console.error(
          'Yotpo course-rating request failed:',
          result.reason
        );
      });

    const totalReviews = products.reduce(
      (total, product) => total + product.reviews,
      0
    );

    if (totalReviews === 0) {
      element.innerHTML = `
        <span
          class="course-rating-stars"
          data-rating="0"
          aria-label="No reviews yet">
        </span>
        <span class="course-rating-count">No reviews yet | (0)</span>
      `;
      return;
    }

    const weightedTotal = products.reduce(
      (total, product) =>
        total + (product.rating * product.reviews),
      0
    );

    const combinedRating = weightedTotal / totalReviews;

    fullStar =`<svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-full" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: 3.5px;">
              <defs>
                <linearGradient id="yotpo_stars_gradient_0.8836846381611055">
                  <stop offset="100%" stop-color="rgba(231,114,27,1)"></stop>
                  <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
                </linearGradient>
              </defs>
              <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(231,114,27,1)" fill="url('#yotpo_stars_gradient_0.8836846381611055')"></path>
            </svg>`;

    halfStar =`<svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-half" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: 8px;">
              <defs>
                <linearGradient id="yotpo_stars_gradient_0.7560376881997944">
                  <stop offset="51%" stop-color="rgba(231,114,27,1)"></stop>
                  <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
                </linearGradient>
              </defs>
              <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(231,114,27,1)" fill="url('#yotpo_stars_gradient_0.7560376881997944')"></path>
            </svg>`;


    stars = '';
    ratingCount = combinedRating;

    for (let i = 0; i < 5; i++) {
      if (ratingCount >= 1){
        stars += fullStar;
        ratingCount--; 
      }
      else if(ratingCount > 0 && ratingCount < 1){
        stars += halfStar;
        ratingCount = 0;
      }
      else {
      }

    }

    element.innerHTML =`
    <div class="yotpo-widget-clear yotpo-bottom-line-scroll-panel" style="display: flex; align-items: flex-start; flex-flow: column wrap;">
      <div style="display: none;"></div>
      
      <div class="yotpo-sr-bottom-line-summary" style="display: flex; flex-direction: row; align-items: flex-start; direction: ltr; cursor: initial;">
        <div style="display: flex;">

          <span role="img" aria-label="${combinedRating.toFixed(1)} out 5 stars rating in total 14 reviews" title="${combinedRating.toFixed(1)} out 5 stars rating in total ${totalReviews} reviews" style="display: flex; flex-direction: row; align-items: center; height: 28px;">
            ${stars}
          </span>
          
            <p class="yotpo-sr-bottom-line-left-panel yotpo-sr-bottom-line-score" aria-hidden="true" style="display: flex; align-self: center; color: rgb(231, 114, 27); font-family: Rubik; font-style: normal; font-weight: 400; font-size: 16px; margin-inline: 0px 10px; margin-bottom: 1px; padding-top: 3px;">
            ${combinedRating.toFixed(1)}
            </p>
          
        </div>
        
            <div class="yotpo-sr-vertical-border" style="display: flex; place-self: center; height: 11px; border-right: 1px solid black; margin-right: 12px; margin-left: 0px;"></div>
        
            <div class="yotpo-sr-bottom-line-right-panel" style="display: flex;">
                <p class="yotpo-sr-bottom-line-text yotpo-sr-bottom-line-text--right-panel" aria-hidden="true" style="white-space: nowrap; font-size: 16px; text-align: start; font-family: Rubik; font-style: normal; font-weight: 400; color: rgb(147, 147, 147); padding-top: 2px; line-height: 28px;">
                (${totalReviews})
                </p>
            </div>
      </div>
    </div>
    `;

  } catch (error) {
    console.error(
      'Unable to load combined Yotpo rating:',
      error
    );
  }
});
  } catch(e) { console.error(e); }
})();

})();
